export default __webpack_public_path__ + "static/media/avatar_arrow_boy9.85af40d2.mp3";